import React, { useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, IconName } from '@/components/Atoms/Icon/Icon';
import { Flex } from '@/components/Atoms/Flex/Flex';
import { Spacer } from 'components/Atoms/Spacer/Spacer';
import { BodyContent } from 'components/BodyContent/BodyContent';
import { Footer } from 'components/Footer/Footer';
import { Header } from 'components/Header/Header';
import { Metadata } from 'components/Metadata/Metadata';
import { Theme } from 'components/Theme/Theme';
import { PageContext, PageReducer } from 'src/context/PageContext';
import { ThemeType } from 'types/publishedAssets';
import { InvitationErrorType } from 'src/serverUtils/InvitationErrorType';
import styles from './Errors.module.scss';

export const errorIconMap: Record<InvitationErrorType, IconName> = {
  [InvitationErrorType.CODE_INVALID]: 'errorCard' as IconName,
  [InvitationErrorType.CODE_ALREADY_USED]: 'smileyFaceCard' as IconName,
  [InvitationErrorType.CODE_REQUIRED]: 'errorCard' as IconName,
};

interface InvitationErrorProps {
  theme: ThemeType;
  title: string;
  description: string;
  iconName: IconName;
  urlParams: Record<string, unknown>;
}

export function InvitationError({ theme, title, description, iconName, urlParams }: InvitationErrorProps) {
  const { t } = useTranslation();
  const initialState = {
    theme,
    urlParams,
    slug: [urlParams.organization as string],
  };
  const [state, dispatch] = useReducer(PageReducer, initialState);

  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <PageContext.Provider value={{ ...state, ...initialState, dispatch }}>
      <Header />
      <Metadata />
      <BodyContent>
        <Spacer customSize={20} orientation="vertical" />
        <Flex flexDirection="column" justifyContent="center" alignItems="center">
          <Icon name={iconName} />
          <div className={styles.title}>{t(title)}</div>
          <div className={styles.description}>{t(description)}</div>
        </Flex>
      </BodyContent>
      <Footer />
      <Theme theme={theme} />
    </PageContext.Provider>
  );
}
